import { Cookies } from 'react-cookie';

import { MiceActivityDonutChartData } from '../types';

import axiosInterceptor from 'api/interceptor/axiosClient';
import { TrapType } from 'components/AnalyticsPage/TrapType';

export const getMiceActivityDonutChartData = async (
  slug: string,
  trapType: TrapType,
  start_date: string,
  end_date: string,
) => {
  const cookies = new Cookies();
  const token = cookies.get('local_access_token');
  const data = await axiosInterceptor.get(`api/v1/traps/activation-signals/object/${slug}/`, {
    headers: {
      Authorization: token,
    },
    params: {
      type: trapType,
      start_datetime: start_date,
      end_datetime: end_date,
    },
  });
  return data.data as MiceActivityDonutChartData[];
};
